import React, { useState, useEffect, useRef } from "react";
import {
  collection,
  getDocs,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase"; // Import your Firebase configuration
import { Modal, Button, Form, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/FacilityTable.css";
import "../style/Admin.css";

export default function AdminUserTable() {
  let unsubscribe;

  const [users, setUsers] = useState([]);
  const [facility, setFacility] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchUserName, setSearchUserName] = useState("");
  const [searchUserEmail, setSearchUserEmail] = useState("");
  const [filterType, setFilterType] = useState("");
  const [sortType, setSortType] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const [showModal, setShowModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);
  const [selectedUserHistory, setSelectedUserHistory] = useState([]);
  const [shownDescription, setShownDescription] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [userNameToDelete, setUserNameToDelete] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [showEditModal, setShowEditModal] = useState(null);
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const nameRef = useRef();
  const emailRef = useRef();
  const contactRef = useRef();
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const docRef = collection(db, "users");
        const querySnapshot = await getDocs(docRef);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("User data: ", data);
        setUsers(data);
        setFilteredUsers(data);

        // Set up a real-time listener for changes
        unsubscribe = onSnapshot(docRef, (snapshot) => {
          const updatedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setUsers(updatedData);
          setFilteredUsers(updatedData);
        });
      } catch (error) {
        console.error("Error fetching users: ", error);
      }
    };

    const fetchFacility = async () => {
      try {
        const docRef = collection(db, "facility");
        const querySnapshot = await getDocs(docRef);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("Facility: ", data);
        setFacility(data);

        // Set up a real-time listener for changes
        unsubscribe = onSnapshot(docRef, (snapshot) => {
          const updatedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setFacility(updatedData);
        });
      } catch (error) {
        console.error("Error fetching facility: ", error);
      }
    };

    fetchUsers();
    fetchFacility();

    return () => {
      // Unsubscribe from the listener when component unmounts
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const handleSearchUserName = (event) => {
    const searchUserName = event.target.value.toLowerCase();
    setSearchUserName(searchUserName);
    filterAndSortUsers(searchUserName, searchUserEmail, sortType);
  };

  const handleSearchUserEmail = (event) => {
    const searchUserEmail = event.target.value.toLowerCase();
    setSearchUserEmail(searchUserEmail);
    filterAndSortUsers(searchUserName, searchUserEmail, sortType);
  };

  //   const handleFilterType = (event) => {
  //     const type = event.target.value;
  //     setFilterType(type);
  //     filterAndSortUsers(searchUserName, searchUserEmail, type, sortType);
  //   };

  const handleSortLastLogin = () => {
    const newSortType = sortType === "asc" ? "desc" : "asc";
    setSortType(newSortType);
    filterAndSortUsers(searchUserName, searchUserEmail, newSortType);
  };

  const filterAndSortUsers = (searchUser, searchEmail, sort) => {
    let filtered = users;

    filtered = filtered.filter((user) =>
      user.name.toLowerCase().includes(searchUser)
    );

    console.log(searchEmail);

    filtered = filtered.filter((user) =>
      user.email.toLowerCase().includes(searchEmail)
    );

    filtered.sort((a, b) => {
      if (sort === "asc") {
        return a.lastLogin - b.lastLogin;
      } else {
        return b.lastLogin - a.lastLogin;
      }
    });

    setFilteredUsers(filtered);
  };

  const showUserDetails = (user) => {
    setSelectedUserDetails(user);
    setShowModal(true);
    setShownDescription("");
    // let tempDes = "";
    // if (facility.isCustomDescription) {
    //   facility.description.forEach((element) => {
    //     if (element !== "Others") {
    //       tempDes = tempDes + element + ", ";
    //     }
    //   });
    //   tempDes += facility.customDescription;
    // } else {
    //   facility.description.forEach((element) => {
    //     tempDes = tempDes + element + ", ";
    //   });
    //   tempDes = tempDes.substring(0, tempDes.length - 2);
    // }
    // setShownDescription(tempDes);
  };

  const handleDelete = async (id, name) => {
    // Show confirmation dialog
    setUserNameToDelete(name);
    setUserToDelete(id);
    setShowConfirmation(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteDoc(doc(db, "users", userToDelete));
      const updatedUsers = users.filter((user) => user.id !== userToDelete);
      console.log("Delete User", userToDelete);
      setUsers(updatedUsers);
      setShowConfirmation(false); // Close confirmation dialog after delete
    } catch (error) {
      console.error("Error deleting user: ", error);
    }
  };

  const editUser = (user) => {
    setEditingUser(user);
    setShowEditModal(true);
    setName(user.name);
    setContact(user.contactNo);
    setEmail(user.email);
  };

  const handleCloseEditModal = () => {
    setEditingUser(null);
    setShowEditModal(false);
  };

  async function handleEdit(e) {
    setError("");
    e.preventDefault();
    if (!nameRef.current.value) {
      setLoading(false);
      return setError("Name should not be empty");
    }

    if (!contactRef.current.value) {
      setLoading(false);
      return setError("Contact should not be empty");
    }

    if (!validateContactNumber(contactRef.current.value)) {
      setError("Contact number must be at least 8 digits");
      setLoading(false);
      return;
    }

    if (!(await updateUser(nameRef.current.value, contactRef.current.value))) {
      setLoading(false);
      return setError("Error in updating user, please try again");
    }

    setLoading(false);
    setShowSuccessModal(true);
    setShowEditModal(false);
  }

  function validateContactNumber(contact) {
    // Regular expression to match a number with a minimum length of 8 digits
    const contactRegex = /^\d{8,}$/;
    return contactRegex.test(contact);
  }

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleViewHistory = async () => {
    setShowHistoryModal(true);
    const q = query(
      collection(db, "usage"),
      where("userID", "==", selectedUserDetails.id)
    );
    const querySnapshot = await getDocs(q);
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Usage History for user ", selectedUserDetails, data);
    const mergedDetails = data.map((usage) => {
      const correspondingItem = facility.find(
        (facility) => facility.id === usage.facilityID
      );
      return correspondingItem ? { ...usage, ...correspondingItem } : null;
    });
    console.log("Usage merge with facility ", mergedDetails);
    const filteredMergedDetails = mergedDetails.filter((item) => item !== null);
    setSelectedUserHistory(filteredMergedDetails);
  };

  const updateUser = async (name, contact) => {
    console.log("User name and contact", name, contact);
    try {
      console.log(editingUser.id);
      const userRef = doc(db, "users", editingUser.id);
      await updateDoc(userRef, {
        name: name,
        contactNo: contact,
      });
      console.log("Update User successfully!");

      return true;
    } catch (error) {
      console.error("Error updating profile:", error);
      return false;
      // Handle error: For example, display an error message to the user
    }
  };

  return (
    <div>
      <div className="table-responsive px-5 my-1 mt-3 mt-sm-2 pt-1">
        <div className="row mb-3">
          <div className="col-md-3">
            <input
              type="text"
              placeholder="Search by user name..."
              value={searchUserName}
              onChange={handleSearchUserName}
              className="form-control"
            />
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <input
              type="text"
              placeholder="Search by user email..."
              value={searchUserEmail}
              onChange={handleSearchUserEmail}
              className="form-control"
            />
          </div>
          {/* <div className="col-md-3 mt-3 mt-md-0">
            <select onChange={handleFilterType} className="form-select">
              <option value="">All Types</option>
              <option value="Toilet">Toilet</option>
              <option value="Rest">Rest</option>
              <option value="Other">Other</option>
            </select>
          </div> */}
          <div className="col-md-3 mt-3 mt-md-0">
            <button onClick={handleSortLastLogin} className="btn custom-button">
              Sort by Last Login (
              {sortType === "asc" ? "Ascending" : "Descending"})
            </button>
          </div>
        </div>
        <table className="table mt-3 mt-md-0">
          <thead>
            <tr className="custom-trow">
              <th className="custom-thead">User</th>
              <th className="custom-thead">Email</th>
              <th className="custom-thead">Contact</th>
              <th className="custom-thead">Last Login</th>
              <th className="custom-thead">Action</th>
              <th className="custom-thead"></th>
            </tr>
          </thead>
          <tbody>
            {usersToShow.map((user) => (
              <tr className="custom-trow" key={user.id}>
                <td data-label="User" className="name-column">
                  {user.name}
                </td>
                <td data-label="Email" className="email-column">
                  {user.email}
                </td>
                <td data-label="Contact " className="contact-column">
                  {user.contactNo}
                </td>
                <td data-label="Last Login" className="login-column">
                  {user.lastLogin &&
                    new Date(user.lastLogin.seconds * 1000).toLocaleString()}
                </td>
                <td data-label="Action" className="action-column">
                  <i
                    className="bi bi-pencil-fill edit-icon mx-2 fs-4"
                    onClick={() => editUser(user)}
                  ></i>
                  <i
                    className="bi bi-trash-fill trash-icon mx-2 fs-4"
                    onClick={() => handleDelete(user.id, user.name)}
                  ></i>
                </td>
                <td>
                  <Button
                    id="button-active"
                    className="custom-button"
                    onClick={() => showUserDetails(user)}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-end align-items-center mt-3">
          <div className="justify-content-center">
            <h6 className="me-3" style={{ color: "grey", fontSize: "15px" }}>
              {currentPage} of {totalPages} pages
            </h6>
          </div>
          <button
            className="btn custom-button me-2"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            className="btn custom-button "
            onClick={nextPage}
            disabled={currentPage === totalPages || totalPages==0}
          >
            Next
          </button>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display selected facility details */}
          {selectedUserDetails && (
            <div>
              <p className="my-1"><strong>Name</strong>: {selectedUserDetails.name}</p>
              <p className="my-1"><strong>Email</strong>: {selectedUserDetails.email}</p>
              <p className="my-1"><strong>Contact</strong>: {selectedUserDetails.contactNo}</p>
              <p className="my-1">
                <strong>LastLogin</strong>:
                {selectedUserDetails.lastLogin &&
                  new Date(
                    selectedUserDetails.lastLogin.seconds * 1000
                  ).toLocaleString()}
              </p>
              <Button
                id="button-active"
                className="custom-button my-1"
                onClick={() => handleViewHistory()}
              >
                Show Usage History
              </Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="button-active"
            className="custom-button"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showHistoryModal} onHide={() => setShowHistoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Usage History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display selected facility details */}
          {selectedUserDetails && (
            <div>
              <p>
                <strong>User</strong>: {selectedUserDetails.name}
              </p>
              <p>
                <strong>Total Usage</strong>: {selectedUserHistory.length}
              </p>
              <p>
                <strong>History</strong>
              </p>
              <div className="history-container">
                {selectedUserHistory.map(
                  (usage, index) =>
                    usage.facilityName && (
                      <div className="history-item mt-2" key={index}>
                        <div>
                          <span>
                            <span>
                              <i className="bi bi-buildings"></i>
                            </span>
                            <strong className="fac-name ms-1">
                              {usage.facilityName}
                            </strong>
                          </span>
                          <div className="mt-1">
                            <span className="type-field">
                              Type: {usage.type}
                            </span>
                            <span className="ms-5">
                              Time:{" "}
                              {usage.usedDateTime &&
                                new Date(
                                  usage.usedDateTime.seconds * 1000
                                ).toLocaleString()}
                            </span>
                            {/* Replace usage.timestamp with the actual timestamp property */}
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="button-active"
            className="custom-button"
            onClick={() => setShowHistoryModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
          <i className="bi bi-trash-fill fs-4 me-2"></i>
          <Modal.Title className="fs-4">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mt-4 d-flex flex-column align-items-center justify-content-center">
          Are you sure to delete user:{" "}
          <p className="name">{userNameToDelete}</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between mt-4">
          <Button
            id="button-active"
            className="custom-button"
            onClick={confirmDelete}
          >
            Confirm
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmation(false)}
            className="cancel-button"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <i className="bi bi-pencil-fill edit-icon mx-2 fs-4"></i>Edit User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Form to edit user details */}
          {editingUser && (
            <div>
              <Form className="custom-form" onSubmit={handleEdit}>
                <Form.Group className="mt-1" id="name">
                  <Form.Label className="custom-label mb-0">Name</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="text"
                    ref={nameRef}
                    value={name && name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mt-1" id="email">
                  <Form.Label className="custom-label mb-0">Email</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="email"
                    ref={emailRef}
                    value={email && email}
                    disabled={true}
                  />
                </Form.Group>

                <Form.Group className="mt-1" id="contact">
                  <Form.Label className="custom-label mb-0">Contact</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="tel"
                    ref={contactRef}
                    value={contact && contact}
                    onChange={(e) => setContact(e.target.value)}
                  />
                </Form.Group>
              </Form>
            </div>
          )}

          {error && <Alert variant="danger mt-2">{error}</Alert>}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between mt-4">
          <Button
            className="custom-button"
            onClick={handleEdit}
            disabled={loading}
          >
            Confirm
          </Button>
          <Button
            variant="secondary"
            onClick={handleCloseEditModal}
            className="cancel-button"
            disabled={loading}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSuccessModal} onHide={handleCloseSuccessModal}>
        <Modal.Header closeButton>
          <Modal.Title>Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>User has been successfully updated.</Modal.Body>
        <Modal.Footer>
          <Button id="customBtn" onClick={handleCloseSuccessModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
